import { FormControl, FormGroup } from '@angular/forms'

export const addFormControl = (controlName: string, controlValue: any, validators = []) => {
  return (formGroup: FormGroup) => {
    formGroup?.addControl(controlName, new FormControl(controlValue, validators))
  }
}

export const addDisabledFormControl = (controlName: string, controlValue: any, validators = []) => {
  return (formGroup: FormGroup) => {
    addFormControl(controlName, { value: controlValue, disabled: true }, validators)(formGroup)
  }
}

export const removeFormControl = (controlName: string) => {
  return (formGroup: FormGroup) => {
    formGroup?.removeControl(controlName)
  }
}

export const isFormControlAvailable = (controlName: string) => {
  return (formGroup: FormGroup) => (getFromControl(controlName)(formGroup) ? true : false)
}

export const getFromControl = (controlName: string) => {
  return (formGroup: FormGroup) => formGroup?.get(controlName)
}